export {};

// Here we store the code that is already checked and proven existing and new
let checkedCode = "";
let reloadCount = 0;

document.addEventListener("started-guest", () => {
    const qs = document.location.search ? document.location.search : '?code=';
    document.location.href = config.routes.login + qs;
});

document.addEventListener("started-user", async () => {
    if (app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation_success;
        return;
    }

    // Check queryParams for code
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code') || '';

    if (code) {
        (app.html.q('#code') as HTMLInputElement).value = code;
    }
});

function submitCheckAccessCode(event: Event): void {
    event.preventDefault();

    if (!window.app) {
        return;
    }

    const form = event.target as HTMLFormElement;

    submitCheckAccessCodeForm(form);
}

function submitCheckAccessCodeForm(form: HTMLFormElement): void {
    app.voyoForms.submit(
        form,
        async (data) => {
            const { code } = data;
            if (!code) {
                return;
            }

            return app.gql.billingCodeExists(code)
                .then(billingCode => {
                    handleBillingCodeResponse(billingCode);
                });
        }
    );
}

function handleBillingCodeResponse(billingCode: any): void {
    if (!billingCode || !billingCode.exists) {
        throw {
            code: '400.100',
            message: '{{T "activation.step3_code.invalidCode" }}'
        };
    }
    if (billingCode.status !== "new" && billingCode.status !== "gift") {
        throw {
            code: '400.100',
            message: '{{T "activation.step3_code.codeAlreadyUsed" }}'
        };
    }
    checkedCode = billingCode.code;
    checkCodeFinished(billingCode);
}

function checkCodeFinished(billingCode: any): void {
    app.html.writeHTML('#codeDescription', billingCode.description);
    app.html.q('#codeImage')?.setAttribute('src', billingCode.imageSrc);
    app.html.show('#codeImage', 'block');

    if (billingCode.isRecurring) {
        app.html.writeHTML('#codeTerms', billingCode.terms);
        app.html.removeClass('#legal_box', 'hidden');
    } else {
        app.html.writeHTML('#codeTerms', '');
        app.html.addClass('#legal_box', 'hidden');
    }

    app.html.hide('#checkCode');
    app.html.show('#submitTerms', 'block');
}

function submitActivateAccessCode(event: Event): void {
    event.preventDefault();

    if (!window.app) {
        return;
    }

    const form = event.target as HTMLFormElement;

    app.voyoForms.submit(
        form,
        async (data) => {
            // Non-recurring accessCodes don't need to have user's agreement. For non-recurring
            // codes we hide  terms checkbox (the #legal_box div).
            if (app.html.hasClass('#legal_box', 'hidden') || data.terms === 'on') {
                return activateAccessCode();
            }

            // User had terms checkbox in form and did not check it.
            throw {
                code: '',
                message: '{{ T "activation.step3.termsCheckRequired" }}'
            };
        }
    );
}

function activateAccessCode(): Promise<any> {
    if (!checkedCode) {
        throw {
            code: '400.100',
            message: '{{T "activation.step3_code.invalidCode" }}'
        };
    }

    return app.gql.accessCode(checkedCode)
        .then(response => {
            // If it is a recurring code we redirect to the payment page
            if (response.code) {
                const queryParams = `?giftCode=${response.code}`;
                const redirectUrl = response.activatedBy === "sms" ? config.routes.activation_sms : config.routes.activation_credit_card_monthly;

                document.location.href = redirectUrl + queryParams;
                return;
            }
            // Otherwise refresh userInfo and redirect when we confirm the code is activated and the user has access
            reloadUserInfo();
        });
}

function reloadUserInfo(): void {
    app.user.loadUserInfo(false)
        .then((user) => {
            if (!user) {
                document.location.href = "/";
                return;
            }
            if (user?.isSubscribed) {
                document.location.href = config.routes.activation_success;
                return;
            }

            // Stop after ~2 minutes (60 * 2s) if the subscription never activates and
            // let the user know the server didn't confirm the activation in time.
            reloadCount++;
            if (reloadCount > 60) {
                app.voyoForms.showCallout('#submitTerms .callout', '{{ T "base.errors.fetchError" }}', 'error');
                return;
            }

            // Check again after 2 seconds, to give the backend some time to process the activation
            setTimeout(() => {
                reloadUserInfo();
            }, 2000);
        });
}


window.submitCheckAccessCode = submitCheckAccessCode;
window.submitActivateAccessCode = submitActivateAccessCode;
